import { render } from "./rewardsPage.vue?vue&type=template&id=e36d1070&scoped=true&ts=true"
import script from "./rewardsPage.vue?vue&type=script&lang=ts"
export * from "./rewardsPage.vue?vue&type=script&lang=ts"

import "./rewardsPage.vue?vue&type=style&index=0&id=e36d1070&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e36d1070"]])

export default __exports__